import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { EMPTY_ARRAY, RESPONSIVE_SIZE } from '../../constants';
import { imageColors } from '../../lib/Color';
import ClipThumbnail from '../ClipThumbnail';
import Link from '../Link';

class ClipThumbnailGrid extends React.PureComponent {
  static propTypes = {
    responsive: PropTypes.number,
    clips: PropTypes.array,
    colorA: PropTypes.string.isRequired,
    colorB: PropTypes.string.isRequired,
  };
  static defaultProps = {
    clips: EMPTY_ARRAY,
  };

  render() {
    const { responsive, clips, colorA, colorB, ...otherProps } = this.props;

    let margins = '0.75rem';
    let flexBasis = '100%';

    if (responsive >= RESPONSIVE_SIZE.TABLET_PORTRAIT) {
      margins = '1.5rem';
      flexBasis = '50%';
    }
    if (responsive >= RESPONSIVE_SIZE.TABLET_LANDSCAPE) {
      flexBasis = '33.33%';
    }

    return (
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            margin: `-${margins}`,
          }}
        >
          {clips.map(clip => {
            return (
              <div
                key={clip.clip_id}
                style={{
                  flex: `0 0 ${flexBasis}`,
                  width: flexBasis,
                }}
              >
                <Link to={`/browse/scene/${clip.scene_slug}/${clip.clip_slug}`}>
                  <ClipThumbnail
                    title={clip.clip_name}
                    backgroundColor={imageColors(clip.clip_colors).dark}
                    lqip={clip.clip_lqip}
                    thumbnail={clip.clip_thumbnail}
                    poster={clip.clip_poster}
                    video={clip.clip_preview_small || clip.clip_preview_large}
                    colorA={colorA}
                    colorB={colorB}
                    length={clip.clip_length}
                    style={{ margin: margins }}
                  />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
  };
}
export default connect(mapStateToProps)(ClipThumbnailGrid);



// WEBPACK FOOTER //
// ./src/components/ClipThumbnailGrid/ClipThumbnailGrid.js